/*
|--------------------------------------------------------------------------
| PUBLIC OFFER STATUS
|--------------------------------------------------------------------------
*/

export const PUBLIC_OFFER_STATUS = {
  ACTIVE: "ACTIVE",
  EXPIRED: "EXPIRED",
  REVOKED: "REVOKED",
  ACCEPTED: "ACCEPTED",
};


/*
|--------------------------------------------------------------------------
| OFFER STATUS
|--------------------------------------------------------------------------
*/

export const OFFER_STATUS = {
  DRAFT: "DRAFT",
  SENT: "SENT",
  ACCEPTED: "ACCEPTED",
  REJECTED: "REJECTED",
  EXPIRED: "EXPIRED",
  CANCELLED: "CANCELLED",
};


/*
|--------------------------------------------------------------------------
| PUBLIC OFFER ROUTES
|--------------------------------------------------------------------------
*/

export const PUBLIC_OFFER_ROUTES = {
  VIEW: "/offer/:token",
  PAYMENT: "/offer/:token/payment",
  SUCCESS: "/offer/:token/success",
};


/*
|--------------------------------------------------------------------------
| PAYMENT STATUS
|--------------------------------------------------------------------------
*/

export const PAYMENT_STATUS = {
  PENDING: "PENDING",
  SUCCESS: "SUCCESS",
  FAILED: "FAILED",
  CANCELLED: "CANCELLED",
};


/*
|--------------------------------------------------------------------------
| MESSAGES
|--------------------------------------------------------------------------
*/

export const PUBLIC_OFFER_MESSAGES = {
  LOADING: "Loading offer...",

  LOAD_ERROR:
    "Unable to load this offer.",

  NOT_FOUND:
    "This offer link is invalid or no longer available.",

  EXPIRED:
    "This offer has expired.",

  REVOKED:
    "This offer link has been revoked.",

  ACCEPTED:
    "This offer has already been accepted.",

  ACCEPT_SUCCESS:
    "Offer accepted successfully.",

  ACCEPT_ERROR:
    "Unable to accept this offer.",
};